import {Component, OnInit, Input, HostBinding} from '@angular/core';

@Component({
  selector: 'taxihandgo-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  @Input()
  @HostBinding("class") type: string = "success";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/alert/alert.component.ts